
import React from "react";
import css from './SectionGrid31.module.css';

const SectionGrid31 = props => {
    const { header, content, footer, backgroundColor } = props;

    return (
        <div className={css.root} style={backgroundColor ? { "backgroundColor": backgroundColor } : null}>

            <div className={css.content}>
                {header}
                <div className={css.gridContainer}>
                    {content}
                </div>
                {footer}
            </div>
        </div>
    );
};

export default SectionGrid31;
